<div class="tw-flex tw-flex-1 tw-flex-col tw-min-h-0" id="filters-panel" *ngIf="filters && filters.length">
  <div class="tw-flex tw-flex-1 tw-flex-col tw-min-h-0 tw-items-center tw-justify-start" id="filters-container">
    <mat-accordion class="w100" multi="false" data-cy="filters-panel">
      <mat-expansion-panel #filterPanel *ngFor="let filter of filters; trackBy: identifier" [attr.data-cy]="filter.id">
        <mat-expansion-panel-header *ngIf="filter.active">
          <div class="tw-flex tw-flex-1 tw-flex-col tw-gap-[5px]">
            <div [class.colorPrimary]="filter.options_selected > 0" class="tw-flex tw-flex-1 tw-items-center tw-justify-start tw-gap-[5px]">
              <ate-icon
                *ngIf="filter.icon"
                [class.colorPrimary]="filter.options_selected > 0"
                class="filter-icon tw-mr-[10px]"
                name="{{ filter.icon }}"></ate-icon>
              <p class="tw-font-bold">{{ filter?.name }}</p>
              <p>&nbsp;-&nbsp;</p>
              <p [class.tw-font-semibold]="filter.options_selected > 0">
                {{ filter?.filters_applied_message }}
              </p>
            </div>
            <div *ngIf="filterPanel.expanded && filter.description" class="filters-description animated fadeIn tw-flex tw-flex-1">
              <p>
                <span>{{ filter.description }}</span>
                <span>&nbsp;</span>
                <span *ngIf="filter.help_link">(<a href="{{ filter.help_link }}" target="_blank">learn more</a>)</span>
              </p>
            </div>
          </div>
        </mat-expansion-panel-header>

        <div *ngIf="filter.active" class="filters-content animated fadeIn tw-flex tw-flex-1 tw-flex-col">
          <div class="filters-controls tw-flex tw-flex-1 tw-flex-wrap">
            <!-- ********************************************* -->
            <!-- ********* SINGLE & MULTIPLE SELECT ********** -->
            <!-- ********************************************* -->
            <div *ngIf="filter.type === filterTypes.SELECT_SINGLE || filter.type === filterTypes.SELECT_MULTIPLE">
              <mat-chip-listbox>
                <mat-basic-chip
                  (click)="optionsChanged(filter, filter.options, option)"
                  *ngFor="let option of filter.options"
                  [attr.data-cy]="'filter-chip-' + option.id"
                  [class.btn-chip-active]="option.selected"
                  class="btn-chip">
                  {{ option.name }}
                </mat-basic-chip>
              </mat-chip-listbox>
            </div>

            <!-- ******************************************* -->
            <!-- *************** DATE PICKER *************** -->
            <!-- ******************************************* -->
            <div *ngIf="filter.type === filterTypes.DATE_PICKER" class="tw-flex-1">
              <div class="filter-calendar-container">
                <mat-calendar
                  (selectedChange)="dateChanged($event)"
                  [(selected)]="selectedDate"
                  [maxDate]="filter.max_date ? filter.max_date : null"
                  [minDate]="filter.min_date ? filter.min_date : null">
                </mat-calendar>
              </div>
            </div>

            <!-- ******************************************* -->
            <!-- ************ DATE RANGE PICKER ************ -->
            <!-- ******************************************* -->
            <div *ngIf="filter.type === filterTypes.DATERANGE_PICKER" class="tw-flex-1">
              <mat-chip-listbox class="tw-mb-10">
                <mat-basic-chip
                  (click)="setPreDefinedDateRange(filter, option)"
                  *ngFor="let option of filter.options"
                  [attr.data-cy]="'filter-chip-' + option.id"
                  [class.btn-chip-active]="option.selected"
                  class="btn-chip">
                  {{ option.name }}
                </mat-basic-chip>
              </mat-chip-listbox>
              <div class="filter-calendar-container">
                <mat-calendar
                  #dateRangeCalendar
                  (selectedChange)="dateRangeChanged($event)"
                  [maxDate]="filter.max_date ? filter.max_date : null"
                  [minDate]="filter.min_date ? filter.min_date : null"
                  [selected]="selectedDateRange">
                </mat-calendar>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div class="border-top-2px tw-box-border tw-flex tw-h-[80px] tw-w-full tw-shrink-0 tw-flex-col tw-pl-6 tw-pr-6">
    <div class="tw-flex tw-flex-1 tw-items-center tw-justify-between">
      <div class="animated fadeIn">
        <p (click)="resetFilters(filters)" class="txtLink" data-cy="btn-reset-filters">Clear All</p>
      </div>
      <div class="animated fadeIn tw-flex tw-flex-1 tw-items-center tw-justify-center tw-gap-[5px]">
        <div [ngClass]="filtersCounter === 0 ? 'bgGrey2' : 'bgPrimary'" class="filters-indicator" data-cy="filters-indicator">
          <p>{{ filtersCounter }}</p>
        </div>
        <p [ngClass]="filtersCounter === 0 ? 'colorGrey2' : 'colorPrimary'">
          <span *ngIf="innerWidth > 480 && filtersCounter !== 1">{{ appStrings.filters.filters_applied }}</span>
          <span *ngIf="innerWidth > 480 && filtersCounter === 1">{{ appStrings.filters.filter_applied }}</span>
          <span *ngIf="innerWidth <= 480">{{ appStrings.filters.filters_applied_mobile }}</span>
        </p>
      </div>
      <div>
        <button
          (click)="viewResults()"
          class="ate-btn btn-submit animated fadeIn tw-flex tw-flex-1 tw-items-center tw-justify-center"
          id="btn-filters-submit"
          data-cy="btn-filters-submit">
          <span class="tw-mr-[5px]">View</span>
          <span *ngIf="totalRecords || totalRecords === 0" data-cy="btn-filters-submit-total-records">{{ totalRecords }}</span>
          <span *ngIf="!totalRecords && totalRecords !== 0" class="btn-loader"></span>
        </button>
      </div>
    </div>
  </div>
</div>
